import React, { FC, ReactElement, useMemo } from 'react';
import { PlatformLinkingConnectionStatus } from '@okletsplay/core';
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useStyles } from './LinkingStatus.styles';
import { Done as DoneIcon } from '@mui/icons-material';
import classNames from 'classnames';

interface LinkingStatusProps {
  status?: PlatformLinkingConnectionStatus;
}

export const LinkingStatus: FC<LinkingStatusProps> = ({ status }) => {
  const theme = useTheme();
  const { classes } = useStyles();

  const isMobileView = useMediaQuery(theme.breakpoints.down('sm'));

  const connectedStatusLabel = useMemo(
    () => (
      <Box className={classNames(classes.connected)}>
        <DoneIcon className={classes.doneIcon} color="primary" />
        {!isMobileView && <Typography>{PlatformLinkingConnectionStatus.Connected}</Typography>}
      </Box>
    ),
    [classes, isMobileView]
  );

  const statuses = useMemo<Record<PlatformLinkingConnectionStatus, ReactElement>>(
    () => ({
      [PlatformLinkingConnectionStatus.NotConnected]: <Typography>Connect</Typography>,
      [PlatformLinkingConnectionStatus.PuuidMissing]: <></>,
      [PlatformLinkingConnectionStatus.HasNotFinishedActivities]: connectedStatusLabel,
      [PlatformLinkingConnectionStatus.Connected]: connectedStatusLabel,
      [PlatformLinkingConnectionStatus.Disconnected]: <></>,
    }),
    [connectedStatusLabel]
  );

  if (!status) {
    return null;
  }

  return <Box className={classes.root}>{statuses[status as PlatformLinkingConnectionStatus]}</Box>;
};
